import type { TaskOdata } from '@experiences/interfaces';
import {
    get,
    getOrchestratorODataRoute,
} from '@experiences/util';
import buildQuery from 'odata-query';

export function getTask(accessToken: string, accountLogicalName: string, tenantName: string, filter: string) {
    const query = buildQuery({
        select: [ 'Title', 'Type', 'Priority', 'Id', 'CreationTime' ],
        filter: {
            IsDeleted: false,
            Status: filter,
        },
        expand: 'AssignedToUser',
        orderBy: [ 'IsCompleted asc', 'Status asc', 'Priority desc', 'CreationTime desc' ] as any,
        top: 5,
    });

    const url = `${getOrchestratorODataRoute(accountLogicalName, tenantName)}/Tasks/UiPath.Server.Configuration.OData.GetTasksAcrossFolders()${query}`;

    return get<TaskOdata>(url, {
        accessToken,
        ignoreBasePath: true,
    });
}
